module.exports = __webpack_public_path__ + "img/bus-8.d91ec354.png";